// extracted by mini-css-extract-plugin
export var backdropBlur = "_7x-0";
export var body = "_7x-5";
export var bodyScroll = "_7x-6";
export var columnFooter = "_7x-7";
export var columnFooterFlush = "_7x-8";
export var contentColumn = "_7x-4";
export var frame = "_7x-3";
export var heroContent = "_7x-c";
export var heroOverlay = "_7x-b";
export var image = "_7x-a";
export var imageWrapper = "_7x-9";
export var modal = "_7x-1";
export var modalMain = "_7x-2";
export var productHeader = "_7x-d";
export var productHeaderIcon = "_7x-e";
export var productHeaderName = "_7x-f";
export var progressIndicator = "_7x-g";